import api from "./axios";
import { apiPaths } from "./endpoints";
import type { AuthUser, ApiMessage } from "@/types";

const apiRoot = `${process.env.API_URL || ""}/api`;

export const getGoogleAuthUrl = () => `${apiRoot}${apiPaths.auth.google}`;

export const logout = () =>
  api.post<ApiMessage>(apiPaths.auth.logout).then((r) => r.data);

export const getMe = () =>
  api.get<AuthUser>(apiPaths.auth.me).then((r) => r.data);

export const deleteMyAccount = () =>
  api.delete<ApiMessage>(apiPaths.auth.me).then((r) => r.data);

export const getLocalKey = () =>
  api
    .get<{ localKey: string }>(apiPaths.auth.localKey)
    .then((r) => r.data.localKey);
